import K2AccountsApi from "../config/Axiosk2_accounts";
import Api from "../config/Axios";

export const loginUser = (email, password) => {
  return K2AccountsApi.post(
    '',
    {email, password},
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const loginUserRocky = (email, password) => {
  return Api.post(
    "api/web/login-web",
    {email, password},
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const loginUserMartRocky = (email, password) => {
  return Api.post(
    "api/web/login-web-mart",
    {email, password},
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};